import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink, useParams} from "react-router-dom";
import {Phase} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const usePhasesTableColumns = () => {

    const {id: playbookId} = useParams();

    const columns: DataTableColumn<Phase>[] = [
        {
            accessor: 'position',
            title: I18n.get('Position'),
            width: '80px',
            render: (item: Phase) => item.position,
        },
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Phase) => (
                <NavLink to={`/playbooks/${playbookId ?? item.playbookId}/phases/${item.id}`}>
                    {item.displayName || item.name}
                </NavLink>
            ),
        },
        {
            accessor: 'description',
            title: I18n.get('Description'),
            width: '1fr',
            render: (item: Phase) => item.description,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Phase) => formatTimestamp(item.created as string),
        },
    ];


    return {
        columns,
    };
};
